import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="alert"
export default class extends Controller {
  static targets = ["topalert"];
  connect() {
    console.log("hello from alert_controller");
    // Remove the top alert after 5 seconds
    setTimeout(() => {
      this.topalertTarget.remove();
    }, 5000);
  }
}
